import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  SearchInput,
  TopToolbar,
  SelectInput,
  ReferenceInput,
  ReferenceField,
  FunctionField,
  EditButton,
  ShowButton,
} from 'react-admin';
import { Card, Typography, Box, Button } from '@mui/material';
import {
  Factory as FactoryIcon,
  ListAlt as ListAltIcon,
} from '@mui/icons-material';
import DeleteWithPasswordButton from '@/components/DeleteWithPasswordButton';
import CustomCreateButton from '@/components/CustomCreateButton';
import RoleIconField from '@/components/RoleIconField';
const PlantListActions = () => (
  <TopToolbar
    sx={{
      alignItems: 'flex-end',
    }}
  >
    <CustomCreateButton
      variant='contained'
      label='Crear Planta'
      sx={{
        height: '40px',
        backgroundColor: 'primary.main',
        '&:hover': {
          backgroundColor: 'primary.dark',
        },
      }}
    />
  </TopToolbar>
);

const plantFilters = [
  <SearchInput
    key='search'
    source='q'
    placeholder='Buscar plantas...'
    alwaysOn
    size='small'
    sx={{
      minWidth: 200,
      mb: 0.5,
    }}
  />,
  <ReferenceInput
    key='client'
    source='clientId'
    reference='clients'
    sort={{ field: 'clientName', order: 'ASC' }}
    alwaysOn
    sx={{ minWidth: 220 }}
  >
    <SelectInput
      optionText='clientName'
      optionValue='id'
      label='Cliente'
      emptyText='Todos los clientes'
      size='small'
    />
  </ReferenceInput>,
];

const PlantsList = () => {
  return (
    <Card elevation={1} sx={{ m: 2, p: 2 }}>
      <Box
        sx={{ p: 3, pt: 2, pb: 2.5, borderBottom: 1, borderColor: 'divider' }}
      >
        <Typography
          variant='h5'
          component='h1'
          sx={{ display: 'flex', alignItems: 'center', gap: 1 }}
        >
          <FactoryIcon color='primary' />
          Gestión de Plantas
        </Typography>
      </Box>
      <List
        title={false}
        filters={plantFilters}
        actions={<PlantListActions />}
        perPage={25}
        sort={{ field: 'plantName', order: 'ASC' }}
        sx={{ '& .RaList-main': { mt: 0 } }}
      >
        <Datagrid
          rowClick='show'
          sx={{
            '& .RaDatagrid-headerCell': { fontWeight: 'bold' },

            '& .MuiTableCell-body': {
              minHeight: 65,
              height: '100%',
              verticalAlign: 'middle',
            },
          }}
        >
          <TextField source='id' label='ID' />
          <TextField source='plantName' label='Nombre de la Planta' />
          <TextField source='clientPhoneContact' label='Teléfono' />
          <TextField source='clientEmail' label='Email' />
          <ReferenceField source='clientId' reference='clients' label='Cliente'>
            <TextField source='clientName' />
          </ReferenceField>

          <FunctionField
            label='Roles y Permisos'
            render={(record: any) => <RoleIconField record={record} />}
          />
          <FunctionField
            label='Variables'
            render={(record: any) => (
              <Button
                variant='outlined'
                size='small'
                startIcon={<ListAltIcon />}
                href={`/#/variables?filter={"plantId":${record.id}}`}
                sx={{
                  textTransform: 'none',
                  whiteSpace: 'nowrap',
                  fontSize: '0.7rem',
                }}
              >
                Ver Variables
              </Button>
            )}
          />
          <ShowButton label={''} />
          <EditButton label={''} />
          <DeleteWithPasswordButton resource='plants' label='Eliminar' />
        </Datagrid>
      </List>
    </Card>
  );
};

export default PlantsList;
